<template>
	<article class="d-news-page-custom">
		<Component :is="PageHero" v-bind="{ ...header, breadcrumb }" />

		<div class="relative mx-layout-margin">
			<aside
				v-if="contentElements && contentElements.length"
				:class="[
					'w-full',
					'>=1024:absolute >=1024:top-0 >=1024:left-0',
					'>=1024:w-2col >=1024:mx-0',
					'>=768:w-8col >=768:mx-auto',
				]"
			>
				<span
					class="uppercase text-h8"
					v-text="`${computedLabel} - ${computedDate}`"
				></span>
			</aside>

			<Component
				:is="BlockList"
				:block-list="contentElements"
				class="w-full"
			/>
		</div>

		<FeedbackForm v-if="activateFeedback" class="mb-lg" />
	</article>
</template>

<script>
import FeedbackForm from '~/components/shared/FeedbackForm';

const MainPageHero = () => import('~/components/main/PageHero');
const SubsitePageHero = () => import('~/components/subsite/PageHero');
const MainBlockList = () => import('~/components/main/BlockList');
const SubsiteBlockList = () => import('~/components/subsite/BlockList');

export default {
	name: 'SubsiteNewsPageCustom',
	components: { FeedbackForm },
	inheritAttrs: false,

	props: {
		header: {
			type: Object,
			default: () => ({}),
		},
		breadcrumb: {
			type: Array,
			required: false,
		},
		contentElements: {
			type: Array,
			default: () => [],
		},
		newsDate: {
			type: String,
			default: '',
		},
		template: {
			type: String,
			required: false,
		},
		activateFeedback: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		PageHero() {
			const map = {
				main: MainPageHero,
				subsite: SubsitePageHero,
			};
			return map[this.$store.state.site.alias] || MainPageHero;
		},
		BlockList() {
			const map = {
				main: MainBlockList,
				subsite: SubsiteBlockList,
			};
			return map[this.$store.state.site.alias] || MainBlockList;
		},
		computedDate() {
			const date = new Date(this.newsDate);
			const day = `0${date.getDate()}`.slice(-2);
			const month = `0${date.getMonth() + 1}`.slice(-2);
			const year = date.getFullYear();

			return `${day}.${month}.${year}`;
		},

		computedLabel() {
			return this.template === 'PressReleasePage'
				? 'Pressemeddelelse'
				: 'Nyhed';
		},
	},
};
</script>

<style lang="postcss">
@screen <1024 {
	.d-news-page-custom aside + .c-block-list .c-block-list__block:first-child {
		@apply mt-lg;
	}
}
</style>
